export default {"src":"/_next/static/media/tick.6e0bfdfe.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};